import React from "react";
import Logo from "../Img/logo.svg";

export default function Navbar() {
    return (
        <div className="nav1">
            <img className="nav" src={Logo} alt="hey"></img>
        </div>
    )
}